// Import Libraries
import React from "react";
import PageSEO from "../../../../Components/SEO/PageSEO";

// Import Components
import HeroComponent from "../../../../Layout/Components/HeroComponent/HeroComponent";
import CustomServerQuoteForm from "./Components/CustomServerQuoteForm/CustomServerQuoteForm";
import ServerStandardsComponent from "../../../../Components/ServerStandardsComponent/ServerStandardsComponent";
import DedicatedServerLocations from "../StandardServersPage/Components/DedicatedServerLocations/DedicatedServerLocations";
import TestNetworkSpeedsComponent from "../StandardServersPage/Components/TestNetworkSpeedsComponent/TestNetworkSpeedsComponent";
import ServerPageIntro from "../../../../Components/ServerPageIntro/ServerPageIntro";

// Import Assets
import CustomServer from "../../../../Assets/Custom_Server.png";

// Import Animation
import FadeInOnScroll from "../../../../util/Animations/FadeInOnScroll";

const CustomDedicatedServersPage = () => {
  // Define structured data for the page
  const customServersSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "WebNX Custom Dedicated Servers",
    "description": "Tailor-made dedicated servers built to your exact specifications, from single CPU to quad CPU setups, with support for up to 4TB+ RAM and GPU integration.",
    "offers": {
      "@type": "AggregateOffer",
      "offers": [
        {
          "@type": "Offer",
          "name": "Custom Dedicated Server",
          "description": "Custom-built servers with unlimited potential, tailored configurations, and unmatched support",
          "availability": "https://schema.org/InStock"
        }
      ]
    },
    "features": [
      "Unlimited Potential",
      "Custom Configurations",
      "Unmatched Support",
      "GPU Integration",
      "High-Performance Hardware"
    ],
    "brand": {
      "@type": "Brand",
      "name": "WebNX"
    },
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "CPU Options",
        "value": "Single to Quad CPU setups"
      },
      {
        "@type": "PropertyValue",
        "name": "RAM Capacity",
        "value": "Up to 4TB+ RAM"
      },
      {
        "@type": "PropertyValue",
        "name": "GPU Support",
        "value": "Available for demanding applications"
      }
    ]
  };

  return (
    <div>
      <PageSEO
        title="Custom Dedicated Servers | Tailored Server Solutions by WebNX"
        description="Get a custom-built dedicated server tailored to your exact specifications. From single CPU to quad CPU setups, GPU integration, and up to 4TB+ RAM. Expert support and premium hardware from Intel, AMD, and SuperMicro."
        keywords="custom dedicated servers, tailored server solutions, GPU integration, high-compute servers, custom server builds, WebNX hosting, enterprise servers, custom hardware, server customization, high-performance servers"
        path="/custom-dedicated-servers"
        image="https://webnx.com/assets/custom-server.jpg"
        schema={customServersSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />

      {/* Hero Section */}
      {/* <HeroComponent
        title="Custom Dedicated Servers"
        subtitle="Custom Solutions For Every Need. <br /> Unleash the Power of <br /> WebNX"
        buttonText1="Shop Servers Now"
        buttonLink1="#filterComponent"
        showButton1={true}
        buttonText2="More Information"
        buttonLink2="#moreInfo"
        showButton2={true}
      /> */}

      {/* Server Page Intro */}
      <FadeInOnScroll>
        <ServerPageIntro
          header="WebNX Custom Dedicated Servers"
          subheader="Tailored Solutions for Any Workload"
          introText="WebNX builds high-performance custom dedicated servers designed to meet your exact specifications. From single to quad CPU setups to GPU-optimized machines, we provide the flexibility you need for AI, rendering, scientific computing, and high-compute tasks. Our high-performance BGP Route Optimized network ensures low-latency, reliable connectivity worldwide."
          image={CustomServer}
          hideImageOnMobile={true}
          features={[
            {
              icon: "FaMicrochip",
              title: "Custom CPU Configurations",
              description: "Single, dual, and quad CPU setups for high-compute workloads."
            },
            {
              icon: "FaBolt",
              title: "GPU-Optimized Servers",
              description: "Integrate specialized GPUs for AI, rendering, and deep learning."
            },
            {
              icon: "FaHdd",
              title: "Premium Hardware",
              description: "Built with components from SuperMicro, Intel, AMD, and LSI."
            },
            {
              icon: "FaNetworkWired",
              title: "High-Performance Networking",
              description: "Optimized BGP routing for fast and reliable global connectivity."
            },
            {
              icon: "FaDatabase",
              title: "Flexible OS Support",
              description: "Compatible with CentOS, Debian, Ubuntu Server, and Windows Server."
            },
            {
              icon: "FaShieldAlt",
              title: "Reliable Security & Support",
              description: "24/7 support, SLA-backed reliability, and advanced security features."
            }
          ]}
        />
      </FadeInOnScroll>

      {/* Custom Server Quote Form */}
      <CustomServerQuoteForm />

      {/* Server Standards */}
      <FadeInOnScroll>
        <ServerStandardsComponent />
      </FadeInOnScroll>

      {/* Dedicated Server Locations */}
      <FadeInOnScroll>
        <DedicatedServerLocations />
      </FadeInOnScroll>

      {/* Test Network Speeds */}
      <FadeInOnScroll>
        <TestNetworkSpeedsComponent />
      </FadeInOnScroll>
    </div>
  );
};

export default CustomDedicatedServersPage;
